import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Ejemplo1 from "../components/ejemplo1";
import Ejemplo2 from "./ejemplo2";
import Ejemplo3 from "./ejemplo3";
import SkeletonLoader from "../components/SkeletonLoader";
import axios from "axios";

export default function Landing() {
  const { slug } = useParams();
  const [landing, setLanding] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchLanding() {
      const urlApi = "https://api.institucional.global.sidom.io";
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(
          `${urlApi}/api/landings?filters[slug]=${slug}&populate[video][populate]=*&populate[Hero][populate]=*&populate[box][populate]=*&populate[contacto][populate]=*&populate[marcas][populate]=*&populate[testimonio][populate]=*`
        );
        if (res.data.data && res.data.data.length > 0) {
          setLanding(res.data.data[0]);
        } else {
          setError("Landing no encontrada");
        }
      } catch (err) {
        setError("Error al cargar la landing");
      } finally {
        setLoading(false);
      }
    }
    fetchLanding();
  }, [slug]);

  if (loading) return <SkeletonLoader />;
  if (error)
    return (
      <div className="text-sidom-orange bg-sidom-blue text-center py-20">
        {error}
      </div>
    );
  if (!landing) return null;

  const layout = landing.Layout || landing.layout;

  return (
    <>
      <header>
        <Navbar />
      </header>

      <main>
        {layout === "ejemplo1" && <Ejemplo1 {...landing} />}
        {layout === "ejemplo2" && <Ejemplo2 {...landing} />}
        {layout === "ejemplo3" && <Ejemplo3 {...landing} />}
      </main>
      <footer>
        <Footer />
      </footer>
    </>
  );
}
